module.exports = __webpack_public_path__ + "static/media/NvphStructure.b9381a0e.webp";